<router-outlet>
    <ngx-spinner></ngx-spinner>
</router-outlet>